/** Poll until a public media URL responds (hero optimizer finished writing to S3). */
export async function waitForMediaUrl(
  mediaUrl: string,
  options?: { maxAttempts?: number; initialDelayMs?: number }
): Promise<void> {
  const maxAttempts = options?.maxAttempts ?? 30;
  const initialDelayMs = options?.initialDelayMs ?? 400;

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      const res = await fetch(mediaUrl, { method: "HEAD", mode: "cors", cache: "no-store" });
      if (res.ok) return;
    } catch {
      // Retry while the optimizer Lambda processes the upload.
    }
    await new Promise((resolve) => window.setTimeout(resolve, initialDelayMs + attempt * 200));
  }

  throw new Error("Image is still processing. Wait a moment and try again.");
}
